import { FC } from 'react';
import { Accordion, Badge, Text } from '@mantine/core';
import { AttributeValueDisplay } from '@/components/ui/AttributeValueDisplay';
import { AttributeValue } from '@/api/AttributeValueApi';
import { AttributeWithValues } from '@/types/creator';
import { RenderAttributeValues } from './RenderAttributeValues';

export interface Props {
	preparedAttribute: AttributeWithValues;
	selectedValue: AttributeValue | null;
	handleClick: (value: AttributeValue) => () => void;
}

export const DisplayAttribute: FC<Props> = ({
	preparedAttribute,
	selectedValue,
	handleClick,
}) => {
	return (
		<Accordion.Item value={preparedAttribute.id}>
			<Accordion.Control
				icon={
					!!selectedValue && (
						<Badge>
							<Text size="sm" fw="bold">
								<AttributeValueDisplay attributeValue={selectedValue} />
							</Text>
						</Badge>
					)
				}
			>
				{preparedAttribute.name}
			</Accordion.Control>
			<Accordion.Panel>
				<RenderAttributeValues
					values={preparedAttribute.attributeValues}
					selectedValue={selectedValue}
					handleClick={handleClick}
				/>
			</Accordion.Panel>
		</Accordion.Item>
	);
};
